/* Patch 13I: focus carousel. Auto-advance, pause on touch/hover, off under reduced motion.
   ES5-clean for old Android (matches the buy box floor). */
(function () {
  'use strict';

  function initCarousel(section) {
    var track = section.querySelector('.ts-focus__track');
    var bar = section.querySelector('.ts-focus__progress-bar');
    if (!track) return;

    var cards = track.querySelectorAll('.ts-focus__card');
    if (cards.length < 2) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;
    var paused = false;

    function step() {
      // Card width plus the flex gap.
      var card = track.querySelector('.ts-focus__card');
      if (!card) return 0;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '14') || 14;
      return card.getBoundingClientRect().width + gap;
    }

    function atEnd() {
      return track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }

    function advance() {
      if (paused) return;
      if (atEnd()) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      }
    }

    function updateProgress() {
      if (!bar) return;
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 0) { bar.style.width = '100%'; return; }
      // Segment sized to visible fraction, moved by scroll position.
      var visibleFraction = track.clientWidth / track.scrollWidth;
      var pos = track.scrollLeft / max; // 0..1
      var segWidth = Math.max(0.12, visibleFraction) * 100;
      bar.style.width = segWidth + '%';
      var travel = 100 - segWidth;
      bar.style.transform = 'translateX(' + (pos * travel) + '%)';
    }

    function start() {
      if (reduceMotion || timer) return;
      timer = window.setInterval(advance, 4000);
    }

    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    // Pause on hover (desktop) and touch (mobile), resume after.
    section.addEventListener('mouseenter', function () { paused = true; });
    section.addEventListener('mouseleave', function () { paused = false; });
    track.addEventListener('touchstart', function () { paused = true; stop(); }, { passive: true });
    track.addEventListener('touchend', function () {
      paused = false;
      window.setTimeout(start, 3000);
    }, { passive: true });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateProgress);
    }, { passive: true });

    // Pause auto-advance when the section is off-screen to save battery.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { start(); } else { stop(); }
        }
      }, { threshold: 0.2 });
      io.observe(section);
    } else {
      start();
    }

    updateProgress();
  }

  function initAll() {
    var sections = document.querySelectorAll('.ts-focus');
    for (var i = 0; i < sections.length; i++) initCarousel(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
